import { useEffect } from 'react';

function useOutsideClick(ref: React.RefObject<HTMLDivElement | null>, callback: () => void) {
  useEffect(() => {
    // Handler to call when a click occurs outside of the referenced element
    const handleClickOutside = (event: MouseEvent) => {
      // Check if the ref is not null and if the click is outside the element
      if (ref && ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };

    // Attach event listener to document for clicks
    document.addEventListener('mousedown', handleClickOutside);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}

export default useOutsideClick;